export default "__VITE_ASSET__BDeMCXvo__"